import { parse } from 'graphql'

export const AVAILABILITY_TIME_FRAGMENT = parse(`
  fragment AvailabilityTimeFields on AvailabilityTime {
    activityId
    id
    minimumTicketsRequired
    spots
    whitelistedResourceOptionIds
    status
    date
    availability {
      resourceOptionId
      qty
    }
    duration {
      name
      id
      length {
        amount
        unit
      }
      visibility
    }
    timezone
    from
    time
    price {
      amount
      currency
    }
    prices {
      resourceOptionId
      pricing {
        listPrice {
          amount
          currency
          formatted
        }
        price {
          amount
          currency
          formatted
        }
        priceDeposit {
          amount
          currency
          formatted
        }
      }
    }
  }
`)
